import React, { useState } from "react";
import "./style.css";
import { NavLink } from 'react-router-dom';
import { AiOutlineSearch } from "react-icons/ai";
import { Collapse } from "react-collapse";
import Corpo from './collapse';
import Title from './title';
import Grid from '@material-ui/core/Grid';
import SideNav from './../../../components/SideNav_PS';

export default function CAD_MedicoEspec() {
    let [search, setSearch] = useState(false);
    return (
        <>
        <SideNav />
        <div id="top-PS-Cadastro-Medico-Especialista">
        <Grid container spacing={0} direction="row" justify="left"  alignItems="center" style={{ marginTop: '-35vh'}}>
            <Grid item xs={2} sm={2} md={1} lg={1} align="center">     
                <NavLink id="voltar-a" to="/tela_ps_cadastro"> <button id="voltar">Voltar</button></NavLink>
            </Grid>
            <Grid item xs={8} sm={8} md={10} lg={10}></Grid>   
            <Grid item xs={2} sm={2} md={1} lg={1} align="center"> 
                <Collapse isOpened={search}>
                    <input id="Tela_PS" type="text" placeholder="pesquisa..." />
                </Collapse>
                <AiOutlineSearch
                    size={"6vh"}
                    onClick={() =>
                        setSearch(!search)
                    }
                    id="Icon-Search-PS"
                />
            </Grid>
        </Grid>
        </div>
            <div id="main-RI-Cadastro-Medico-Especialista">
                <Title />
                <Corpo />
            </div>
        </>
    );
}